import { useState,useEffect } from 'react';
import { Card,Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { headerStyle} from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json'
import exportToExcelFromUpload from 'shared/utils/exportToExcelFromUpload'
import UploadResults from './UploadResults';
import Headers from './headersList.json';
import UploadModal from './UploadModal';

export default function UploadFile() {

    const [fileList, setFileList] = useState([]);
    const [cancelledContractErrors, setCancelledContractErrors] = useState([])
    const [newContractErrors, setNewContractErrors] = useState([])
    const [returnedContractErrors, setReturnedContractErrors] = useState([])
    const [changedContractErrors, setChangedContractErrors] = useState([])
    const [genericContractErrors, setGenericContractErrors] = useState([])
    const [cancelledContractSuccess, setCancelledContractSuccess] = useState([])
    const [newContractSuccess, setNewContractSuccess] = useState([])
    const [returnedContractSuccess, setReturnedContractSuccess] = useState([])
    const [changedContractSuccess, setChangedContractSuccess] = useState([])
    const [exportFileName, setExportFileName] = useState('')
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);


    const constructExportArray = (...args) => {

        const mergedArray = [
            `${Headers.OBDSEND} Πρόβλημα: ${args[0].length} Επιτυχία:${args[1].length}`,
            ...args[0],
            ...args[1],
            `${Headers.OBDRETURN} Πρόβλημα: ${args[2].length} Επιτυχία:${args[3].length}`,
            ...args[2],
            ...args[3],
            `${Headers.OBDCANCEL} Πρόβλημα: ${args[4].length} Επιτυχία:${args[5].length}`,
            ...args[4],
            ...args[5],
            `${Headers.OBDCHANGE} Πρόβλημα: ${args[6].length} Επιτυχία:${args[7].length}`,
            ...args[6],
            ...args[7],
            `${Headers.OBDGENERAL} Πρόβλημα: ${args[8].length} Επιτυχία:${0}`,
            ...args[8],
        ]
        return (mergedArray)
    }

    useEffect(() => {
        if (loading === false) {
            exportToExcelFromUpload(
                constructExportArray(
                    newContractErrors,
                    newContractSuccess,
                    returnedContractErrors,
                    returnedContractSuccess,
                    cancelledContractErrors,
                    cancelledContractSuccess,
                    changedContractErrors,
                    changedContractSuccess,
                    genericContractErrors),exportFileName)
        }
    }, [loading])

    const parseErrorResponse = (response) => {
        const cancelledErrors = [];
        response.cancelledContractErrors.forEach(contract => {
            contract.errors.forEach(error => {
                cancelledErrors.push(error.errorName)
            })
        });
        const newErrors = [];
        response.newContractErrors.forEach(contract => {
            contract.errors.forEach(error => {
                newErrors.push(error.errorName)
            })
        });
        const returnedErrors = [];
        response.returnedContractsErrors.forEach(contract => {
            contract.errors.forEach(error => {
                returnedErrors.push(error.errorName)
            })
        });
        const changedErrors = [];
        response.changedContractsErrors.forEach(contract => {
            contract.errors.forEach(error => {
                changedErrors.push(error.errorName)
            })
        });
        return { cancelledErrors, newErrors, returnedErrors, changedErrors }
    }


    const parseSucessResponse = (response) => {
        const cancelled = [];
        response.cancelledContracts.forEach(contract => {
            cancelled.push(`Η Ακύρωση του Συμβολαίου με Αριθμό ${contract.policyNo}} στο Sheet Ακυρώσεις OBD καταχωρήθηκε με επιτυχία`)
        });

        const newCont = [];
        response.newContracts.forEach(contract => {
            newCont.push(`Το Συμβολαίο με Αριθμό ${contract.policyNo} στο Sheet Αποστολές OBD καταχωρήθηκε με επιτυχία`)
        });

        const returned = [];
        response.returnedContracts.forEach(contract => {
            returned.push(contract.policyNo `Η Επιστροφή OBD για το Συμβόλαιο με Αριθμό ${contract.policyNo}} στο Sheet Επιστροφές OBD καταχωρήθηκε με επιτυχία`)
        });

        const changed = [];
        response.changedContracts.forEach(contract => {
            changed.push(`Η Αλλαγή πακέτου για το Συμβόλαιο με Αριθμό ${contract.policyNo} στο Sheet Αλλαγές Πακέτου καταχωρήθηκε με επιτυχία`)
        });
        return { cancelled, newCont, returned, changed }
    }

    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
        setUploading(true);
        }
        setLoading(true)
        setCancelledContractErrors([])
        setNewContractErrors([])
        setReturnedContractErrors([])
        setChangedContractErrors([])
        setGenericContractErrors([])

        setCancelledContractSuccess([])
        setNewContractSuccess([])
        setReturnedContractSuccess([])
        setChangedContractSuccess([])

        setFileList(info.fileList.slice(-1));
        setExportFileName(info.fileList[0].name.slice(0,info.fileList[0].name.length-5));

        if (info.file.status === 'done') {
            const errorMessages = parseErrorResponse(info.file.response)
            setReturnedContractErrors(errorMessages.returnedErrors)
            setChangedContractErrors(errorMessages.changedErrors)
            setCancelledContractErrors(errorMessages.cancelledErrors)
            setNewContractErrors(errorMessages.newErrors)

            const sucessMessages = parseSucessResponse(info.file.response)
            setReturnedContractSuccess(sucessMessages.returned)
            setChangedContractSuccess(sucessMessages.changed)
            setCancelledContractSuccess(sucessMessages.cancelled)
            setNewContractSuccess(sucessMessages.newCont)
            setUploading(false);
            setLoading(false);

        } else if (info.file.status === 'error') {
            const genericErrors = Object.entries(info.file.response).map((error) => error[0].concat(" : ").concat(error[1]))
            setGenericContractErrors(genericErrors);
            setLoading(false);
             setUploading(false);
        }
    };

    return (
        <Card type="inner" headStyle={headerStyle} title="Πατήστε το κουμπί και επιλέξτε αρχείο" style={{ textAlign: 'center' }} >
            <UploadModal
                action={EndPoints.EXCEL.UPLOADEXCEL}
                onChange={handleChange}
                fileList={fileList}
                disabled={uploading}
            >
                <Button  disabled={uploading} loading={uploading} icon={<UploadOutlined />} style={{ backgroundColor: '#e6e6e6' }} htmlType="submit" >Upload</Button>
            </UploadModal>
            {loading === false ? (
                <>
                    <UploadResults errorList={newContractErrors} successList={newContractSuccess} title={Headers.OBDSEND} successTitle="Επιτυχία" errorTitle="Πρόβλημα" />
                    <UploadResults errorList={returnedContractErrors} successList={returnedContractSuccess} title={Headers.OBDRETURN} successTitle="Επιτυχία" errorTitle="Πρόβλημα" />
                    <UploadResults errorList={cancelledContractErrors} successList={cancelledContractSuccess} title={Headers.OBDCANCEL} successTitle="Επιτυχία" errorTitle="Πρόβλημα" />
                    <UploadResults errorList={changedContractErrors} successList={changedContractSuccess} title={Headers.OBDCHANGE} successTitle="Επιτυχία" errorTitle="Πρόβλημα" />
                    <UploadResults successList={[]} errorList={genericContractErrors} title={Headers.OBDGENERAL} successTitle="Επιτυχία" errorTitle="Πρόβλημα" />
                </>
            ) : null}
        </Card>
    )
}
